(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jhangvi-cart-modern"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jhk__form').forEach(function (form) {
  function save() {
    form.classList.add('is-busy');
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }
  form.querySelectorAll('[data-q]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.q, 10));
      save();
    });
  });
  form.querySelectorAll('.jhk__qty input').forEach(function (i) { i.addEventListener('change', save); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
